module.exports = __webpack_public_path__ + "media/day/338-2c2a308f.svg";